document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Cart drawer open/close ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.querySelector('.cart-drawer-overlay');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    renderCartDrawer();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  /* ---------- Render cart drawer contents from Shopify Cart API ---------- */
  function renderCartDrawer() {
    var container = document.getElementById('cart-drawer-items');
    if (!container) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCountUI(cart.item_count);

        if (!cart.items.length) {
          container.innerHTML = '<p style="padding:40px 0;color:var(--color-ink-soft);">Your bag is empty.</p>';
          return;
        }
        container.innerHTML = cart.items.map(function (item) {
          return (
            '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid var(--color-line);">' +
              '<img src="' + item.image + '" width="72" height="72" style="object-fit:cover;">' +
              '<div style="flex:1;">' +
                '<div style="font-size:13px;margin-bottom:4px;">' + item.product_title + '</div>' +
                '<div style="font-size:12px;color:var(--color-ink-soft);">Qty ' + item.quantity + '</div>' +
                '<div style="font-size:12px;margin-top:4px;">' + formatMoney(item.line_price) + '</div>' +
              '</div>' +
            '</div>'
          );
        }).join('');
      });
  }

  function updateCartCountUI(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var hotbarBadge = document.querySelector('.mobile-hotbar__badge');
    if (hotbarBadge) {
      hotbarBadge.textContent = count;
      hotbarBadge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { openCart(); })
        .catch(function (err) { console.error(err); });
    });
  });

  /* ---------- Variant / option swatch selection ---------- */
  document.querySelectorAll('.swatches').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.swatch');
      if (!btn) return;
      group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var hiddenInput = group.parentElement.querySelector('input[type="hidden"]');
      if (hiddenInput) hiddenInput.value = btn.dataset.value;
    });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('.qty-selector').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value || '1', 10);
        val = btn.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('.product__thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product__gallery-main img');
      if (main) main.src = thumb.dataset.full || thumb.src;
      document.querySelectorAll('.product__thumbs img').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('.header-burger');
  var nav = document.querySelector('.site-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
    });
  }

  /* ---------- Header: hide on scroll down, reveal on scroll up ---------- */
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var lastY = window.scrollY;
    var revealThreshold = header.offsetHeight + 40; // don't hide until past header height
    var deltaThreshold = 6; // ignore tiny jitter/bounce scrolling
    var ticking = false;

    function update() {
      var currentY = window.scrollY;
      var diff = currentY - lastY;

      if (currentY < revealThreshold) {
        header.classList.remove('site-header--hidden');
      } else if (diff > deltaThreshold) {
        header.classList.add('site-header--hidden');
      } else if (diff < -deltaThreshold) {
        header.classList.remove('site-header--hidden');
      }

      lastY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  })();

  /* ---------- Cinematic scroll fade for product cards ---------- */
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var cards = Array.prototype.slice.call(document.querySelectorAll('.product-card'));
    if (!cards.length) return;

    var ticking = false;

    function clamp01(v) { return Math.max(0, Math.min(1, v)); }
    function mapRange(v, a, b, c, d) {
      var t = clamp01((v - a) / (b - a));
      return c + t * (d - c);
    }

    function update() {
      var vh = window.innerHeight;

      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        var opacity = 1, translateY = 0, scale = 1;

        if (rect.top > vh * 0.82) {
          /* entering from below: fade + rise in */
          opacity = mapRange(rect.top, vh, vh * 0.8, 0, 1);
          translateY = mapRange(rect.top, vh, vh * 0.8, 46, 0);
        } else if (rect.bottom < vh * 0.26) {
          /* exiting past the top: fade + settle back, like a scene dissolve */
          opacity = mapRange(rect.bottom, -20, vh * 0.26, 0, 1);
          scale = mapRange(rect.bottom, -20, vh * 0.26, 0.94, 1);
        }

        card.style.opacity = opacity;
        card.style.transform = 'translateY(' + translateY + 'px) scale(' + scale + ')';
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  })();
});
